(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-buy"] && !Shopify.designMode) return;
  try {
    /* Buy now: go straight to checkout with just this item, using the card's quantity */
  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-card-buy-now]') : null;
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const form = button.closest('form');
    const variantId = form?.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, parseInt(quantityInput?.value ?? '1', 10) || 1);
    const root = window.Shopify?.routes?.root || '/';

    button.setAttribute('aria-busy', 'true');
    window.location.href = `${root}cart/${variantId}:${quantity}`;
  });
  } catch(e) { console.error(e); }
})();

})();
